<div class="p-2">
  <div class="link text-center align-middle container-fluid w-100 p-0">
    <a href="{{field.value}}" target="_blank">{{field.text}}</a>
  </div>
</div>

